/* eslint-disable jsx-a11y/alt-text */
import {
  ArrowLeftIcon,
  CameraIcon,
  PhotographIcon,
  RefreshIcon,
} from "@heroicons/react/outline";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { ROUTES } from "Route/ConstantRoute";
import Webcam from "react-webcam";
import axios from "axios";
import { handleErrorGlobal, handleSuccess, handleWarning } from "Helper";
import { fetchApiFormdata } from "Config/fetchApiFormdata";
import { decryptNik } from "Config/cripto";

function CreateWatchlist() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState("");
  const [responseCheckingImage, setResponseCheckingImage] = useState({
    status: null,
    message: "",
    uuid: "",
  });

  // ==================== State for select master data ==================== //
  const [dataGender, setDataGender] = useState([]);
  const [dataBloodType, setDataBloodType] = useState([]);
  const [dataReligion, setDataReligion] = useState([]);
  const [dataMaritalType, setDataMaritalType] = useState([]);
  const [dataNationality, setDataNationality] = useState([]);
  const [images, setImages] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  // console.log(previewUrls, 'previewUrls')
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);

  const formDataArray = images.map((image) => {
    const formData = new FormData();
    formData.append("file", image);
    return formData;
  });

  const [value, setValue] = useState({
    uuid_person_fr: null,
    nik: "",
    full_name: "",
    place_of_birth: "",
    address: "",
    date_of_birth: null,
    gender_type_id: "",
    bloodTypeId: "",
    religionId: "",
    maritalTypeId: "",
    nationalityId: "",
    caseDescription: "",
    occupation: "",
    images: null,
  });
  // console.log(value, "value");
  // console.log(formDataArray, "formDataArray");
  // console.log(responseCheckingImage, "responseCheckingImage");

  // ==================== Get data master ==================== //
  const getDataGender = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().get(`/gender/get-list`);
      setDataGender(response.data?.data);
      getDataBloodType();
    } catch (err) {
      setDataGender([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataBloodType = async () => {
    try {
      const response = await fetchApi().get(`/blood-type/get-list`);
      setDataBloodType(response.data?.data);
      getDataReligion();
    } catch (err) {
      setDataBloodType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataReligion = async () => {
    try {
      const response = await fetchApi().get(`religion-type/get-list`);
      setDataReligion(response.data?.data);
      getDataMaritalType();
    } catch (err) {
      setDataReligion([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataMaritalType = async () => {
    try {
      const response = await fetchApi().get(`/marital-type/get-list`);
      setDataMaritalType(response.data?.data);
      getDataNationality();
    } catch (err) {
      setDataMaritalType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataNationality = async () => {
    try {
      const response = await fetchApi().get(`/nationality-type/get-list`);
      setDataNationality(response.data?.data);
      setIsLoading(false);
    } catch (err) {
      setDataNationality([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  useEffect(() => {
    getDataGender();
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      const formDataArray = images.map((images) => {
        return images;
      });

      setValue((prev) => ({
        ...prev,
        nik: decryptNik(value.nik),
        images: formDataArray, // Update value.images dengan formData
      }));
    }
  }, [images]); // Akan dijalankan setiap kali images berubah

  // ==================== Default ==================== //
  const goBack = () => {
    navigate(ROUTES.management_data.watchlist.watchlist_home);
  };
  const handleError = (error) => {
    Notify.error({
      title: "Gagal",
      description: error?.response?.data?.message,
    });
  };

  // console.log(enkripsi, "enkripsi");
  // console.log(decryptedNik, "decryptedNik");

  const createData = async () => {
    const formData = new FormData();
    formData.append("uuid_person_fr", value.uuid_person_fr);
    formData.append("nik", value.nik);
    formData.append("full_name", value.full_name);
    formData.append("place_of_birth", value.place_of_birth);
    formData.append("address", value.address);
    formData.append(
      "date_of_birth",
      moment(value.date_of_birth, "YYYY-MM-DD").format("DD-MM-YYYY")
    );
    formData.append("gender_type_id", value.gender_type_id);
    formData.append("bloodTypeId", value.bloodTypeId);
    formData.append("religionId", value.religionId);
    formData.append("maritalTypeId", value.maritalTypeId);
    formData.append("nationalityId", value.nationalityId);
    formData.append("caseDescription", value.caseDescription);
    formData.append("occupation", value.occupation);
    images.forEach((image) => {
      formData.append("images", image);
    });

    try {
      setIsLoading(true);

      const response = await fetchApiFormdata().post(
        `/watchlist/create`,
        formData
      );
      setIsLoading(false);
      handleSuccess(response.data?.message);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (images?.length === 0) {
      setErrorMessage("Foto tidak boleh kosong");
    } else {
      setErrorMessage("");
      createData();
    }
  };

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);

    if (files.length + images.length > 5) {
      handleWarning("Maksimal 5 gambar!");
      return;
    }

    if (files[0]) {
      const isFrontal = await checkFrontalImage(files[0]);
      if (isFrontal?.status) {
        handleWarning(isFrontal?.response?.data?.message);
        fileInputRef.current.value = "";
        return;
      }
      // console.log(isFrontal, "isFrontal");
      if (isFrontal < 0.65 && images.length === 0) {
        handleWarning("Gambar pertama harus frontal!");
        fileInputRef.current.value = "";
        return;
      }
    }

    const newImages = [...images, ...files];
    const newPreviewUrls = newImages.map((file) => URL.createObjectURL(file));

    setImages(newImages);
    setPreviewUrls(newPreviewUrls);
    fileInputRef.current.value = "";
  };

  const handleRemoveImage = (index) => {
    previewUrls.forEach((url) => URL.revokeObjectURL(url));
    if (index === 0) {
      setImages([]);
      setPreviewUrls([]);
      setValue({
        uuid_person_fr: null,
        nik: "",
        full_name: "",
        place_of_birth: "",
        address: "",
        date_of_birth: "",
        gender_type_id: "",
        bloodTypeId: "",
        religionId: "",
        maritalTypeId: "",
        nationalityId: "",
        caseDescription: "",
        occupation: "",
        images: null,
      });
    } else {
      const newImages = images.filter((_, i) => i !== index);
      const newPreviewUrls = previewUrls.filter((_, i) => i !== index);
      setImages(newImages);
      setPreviewUrls(newPreviewUrls);
    }
  };

  const checkFrontalImage = async (image) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", image);

      const response = await fetchApi().post(
        "/watchlist/checking-image",
        formData
      );
      // console.log(response?.data);
      let checkScore;
      if (response?.data?.score) {
        checkScore = response?.data?.score;
        const res = response.data?.data;
        // console.log(response?.data?.data, " response?.data");
        setValue({
          ...value,
          uuid_person_fr: res?.uuid,
          nik: res?.nik,
          full_name: res?.fullName,
          place_of_birth: res?.placeOfBirth,
          address: res?.address,
          date_of_birth: moment(res?.dateOfBirth).format("YYYY-MM-DD"),
          gender_type_id: res?.gender_id,
          bloodTypeId: res?.bloodTypeId,
          religionId: res?.religionId,
          maritalTypeId: res?.maritalTypeId,
          nationalityId: res?.nationalityTypeId,
          // caseDescription: res?.caseDescription,
          occupation: res?.occupation,
        });
        setResponseCheckingImage(response.data);
      } else {
        setResponseCheckingImage({});
        // checkScore = false;
      }
      setIsLoading(false);
      return checkScore;
    } catch (error) {
      setIsLoading(false);
      console.error("Error checking frontal image", error);
      return error;
    }
  };

  const uploadImage = async (image, index) => {
    const formData = new FormData();
    formData.append("image", image);

    try {
      const response = await fetchApi().post("/upload", formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        },
      });

      return response.data.success;
    } catch (error) {
      console.error(`Error uploading image ke-${index + 1}`, error);
      return false;
    }
  };

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Tambah Data Daftar Pencarian Orang
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex justify-between items-center px-5 w-full">
            <div className="w-2/4">
              <button
                type="submit"
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-center items-center py-5 px-5 w-full ">
            <div className="w-full h-80 bg-white shadow-lg rounded-lg p-6 mt-10">
              <h2 className="text-xl font-semibold mb-4">
                Upload Maksimal 5 Gambar
              </h2>

              <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={handleImageChange}
                accept="image/*"
                // required
                disabled={uploading}
                className="block  text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-500 file:text-white hover:file:bg-blue-600 cursor-pointer"
              />

              {<div className="text-red-500 text-sm mt-2">{errorMessage}</div>}

              {uploading && (
                <div className="w-full bg-gray-200 rounded-full h-2.5 mt-4">
                  <div
                    className="bg-blue-500 h-2.5 rounded-full transition-all"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
              )}
              <div className="w-full flex justify-start ">
                <div>
                  <div className="max-w-2xl mx-auto ">
                    {previewUrls.length > 0 && (
                      <div className="mt-4 grid grid-cols-5 gap-4">
                        {previewUrls.map((url, index) => (
                          <div key={index} className="relative">
                            <img
                              src={url}
                              alt={`Preview ${index + 1}`}
                              className="w-full h-36 object-cover rounded-md shadow-md"
                            />
                            <button
                              onClick={() => handleRemoveImage(index)}
                              className="absolute top-1 right-1 bg-red-600 text-white text-xs px-2 py-1 rounded-full shadow-md hover:bg-red-700"
                            >
                              {index === 0 ? "🗑️" : "❌"}
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="register_face_nik"
                className="flex block text-sm font-medium leading-6"
              >
                NIK
              </label>
              <div className="mt-2">
                <input
                  id="register_face_nik"
                  name="register_face_nik"
                  type="text"
                  maxLength={16}
                  disabled={isLoading}
                  value={value.nik}
                  placeholder="Masukkan NIK"
                  onChange={(e) => setValue({ ...value, nik: e.target.value })}
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="register_face_full_name"
                className="flex block text-sm font-medium leading-6"
              >
                Nama Lengkap
              </label>
              <div className="mt-2">
                <input
                  id="register_face_full_name"
                  name="register_face_full_name"
                  type="text"
                  disabled={isLoading}
                  placeholder="Masukkan Nama Lengkap"
                  value={value.full_name}
                  onChange={(e) =>
                    setValue({ ...value, full_name: e.target.value })
                  }
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="register_face_place_of_birth"
                className="flex block text-sm font-medium leading-6"
              >
                Tempat Lahir
              </label>
              <div className="mt-2">
                <input
                  id="register_face_place_of_birth"
                  name="register_face_place_of_birth"
                  type="text"
                  placeholder="Masukan Tempat Lahir"
                  disabled={isLoading}
                  value={value.place_of_birth}
                  onChange={(e) =>
                    setValue({ ...value, place_of_birth: e.target.value })
                  }
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className="mb-2 w-2/4">
              <label
                htmlFor="register_face_date_of_birth"
                className="flex block text-sm font-medium leading-6"
              >
                Tanggal Lahir
              </label>
              <div className="mt-2">
                <input
                  id="register_face_date_of_birth"
                  name="register_face_date_of_birth"
                  type="date"
                  disabled={isLoading}
                  value={value.date_of_birth}
                  placeholder="DD-MM-YYYY"
                  onChange={(e) =>
                    setValue({ ...value, date_of_birth: e.target.value })
                  }
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="register_face_nationality_id"
                className="flex block text-sm font-medium leading-6"
              >
                Kewarganegaraan
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_nationality_id"
                    name="register_face_nationality_id"
                    disabled={isLoading}
                    value={value.nationalityId}
                    onChange={(e) =>
                      setValue({ ...value, nationalityId: e.target.value })
                    }
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Status
                    </option>
                    {Array.isArray(dataNationality) &&
                      dataNationality?.map((item) => (
                        <option value={item?.id} key={item?.id}>
                          {item?.nationality_type_name}
                        </option>
                      ))}
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2 w-2/4">
              <label
                htmlFor="register_face_occupation"
                className="flex block text-sm font-medium leading-6"
              >
                Pekerjaan
              </label>
              <div className="mt-2">
                <input
                  id="register_face_occupation"
                  name="register_face_occupation"
                  type="text"
                  placeholder="Masukan Pekerjaan"
                  disabled={isLoading}
                  value={value.occupation}
                  onChange={(e) =>
                    setValue({ ...value, occupation: e.target.value })
                  }
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="register_face_gender_id"
                className="flex block text-sm font-medium leading-6"
              >
                Jenis Kelamin
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_gender_id"
                    name="register_face_gender_id"
                    disabled={isLoading}
                    value={value.gender_type_id}
                    onChange={(e) =>
                      setValue({ ...value, gender_type_id: e.target.value })
                    }
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Jenis Kelamin
                    </option>
                    {Array.isArray(dataGender) &&
                      dataGender?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.gender_name}
                        </option>
                      ))}
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2 w-2/4">
              <label
                htmlFor="register_face_marital_type"
                className="flex block text-sm font-medium leading-6"
              >
                Status Perkawinan
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_marital_type"
                    name="register_face_marital_type"
                    value={value.maritalTypeId}
                    disabled={isLoading}
                    onChange={(e) =>
                      setValue({ ...value, maritalTypeId: e.target.value })
                    }
                    className={`${
                      isLoading ? "bg-zinc-100" : ""
                    } h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Status Perkawinan
                    </option>
                    {Array.isArray(dataMaritalType) &&
                      dataMaritalType?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.marital_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="register_face_blood_type_id"
                className="flex block text-sm font-medium leading-6"
              >
                Golongan Darah
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_blood_type_id"
                    name="register_face_blood_type_id"
                    disabled={isLoading}
                    value={value.bloodTypeId}
                    onChange={(e) =>
                      setValue({ ...value, bloodTypeId: e.target.value })
                    }
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Golongan Darah
                    </option>
                    {Array.isArray(dataBloodType) &&
                      dataBloodType?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.blood_type_name}
                        </option>
                      ))}
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2 w-2/4">
              <label
                htmlFor="register_face_religion_id"
                className="flex block text-sm font-medium leading-6"
              >
                Agama
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_religion_id"
                    name="register_face_religion_id"
                    value={value.religionId}
                    disabled={isLoading}
                    onChange={(e) =>
                      setValue({ ...value, religionId: e.target.value })
                    }
                    className={`${
                      isLoading ? "bg-zinc-100" : ""
                    } h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Agama
                    </option>
                    {Array.isArray(dataReligion) &&
                      dataReligion?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.religion_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-full">
              <label
                htmlFor="register_face_address"
                className="flex block text-sm font-medium leading-6"
              >
                Alamat Tempat Tinggal
              </label>
              <div className="mt-2">
                <textarea
                  id="register_face_address"
                  name="register_face_address"
                  disabled={isLoading}
                  value={value.address}
                  placeholder="Masukkan Alamat Tempat Tinggal"
                  onChange={(e) =>
                    setValue({ ...value, address: e.target.value })
                  }
                  className="h-28 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-full">
              <label
                htmlFor="register_face_address"
                className="flex block text-sm font-medium leading-6"
              >
                Kasus Kriminalitas
              </label>
              <div className="mt-2">
                <textarea
                  id="register_face_address"
                  name="register_face_address"
                  disabled={isLoading}
                  value={value.caseDescription}
                  placeholder="Masukkan Kasus Kriminalitas"
                  onChange={(e) =>
                    setValue({ ...value, caseDescription: e.target.value })
                  }
                  className="h-28 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end mr-5">
            <button
              type="submit"
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}
export default CreateWatchlist;
